/**
history-date-tracker
*/


<template>
    <div class="history-date-tracker history-content">
        <div><span v-if="showLeftChevron" v-on:click="moveBackwards"><</span></div>

        <div>
            <select>
                <option v-for="y in allYears" v-on:click.prevent="changeYear" v-bind:selected="y === currentYear">
                    {{y}}
                </option>
            </select>
        </div>

        <div><span v-if="showRightChevron" v-on:click="moveForwards">></span></div>
    </div>
</template>


<script>


export default {
    name: "history-date-tracker",
    components: {},
    props: {
        currentYear: {required: true},  // allow coercing between num/str
        allYears: {type: Array, required: true}
    },
    data: function () {
        return {}
    },
    methods: {
        changeYear: function (e) {
            document.getElementById(e.target.value).scrollIntoView()
        },
        moveForwards () {
            document.getElementById(this.allYears[this.allYears.indexOf(this.currentYear) + 1]).scrollIntoView()
        },
        moveBackwards () {
            document.getElementById(this.allYears[this.allYears.indexOf(this.currentYear) - 1]).scrollIntoView()
        }
    },
    computed: {
        showLeftChevron () {
            return this.currentYear !== this.allYears[0]
        },
        showRightChevron () {
            return this.currentYear !== this.allYears[this.allYears.length - 1]
        }
    },
    watch: {},
    mounted: function () {
    }
}
</script>


<style lang="scss">
    @import "../../../styles/variables.scss";

    .history-date-tracker {
        border: 1px solid $mcs-green-highlight;
        border-radius: 5px;

        position: sticky;
        margin-top: 20px;
        top: 0;
        overflow: visible !important;
        z-index: 1001;
        display: flex;
        justify-content: space-between;
        min-height: 50px;

        background: $light-blue-background;

        > div:nth-child(1), > div:nth-child(3) {
            font-size: 400%;
            line-height: 50px;
            max-width: 50px;
            cursor: pointer;
            user-select: none;

            &:hover {
                color: $mcs-green-highlight;
            }
        }
        > div:nth-child(2) {
            flex-grow: 4;
            font-size: 130%;
            display: flex;
            align-items: center;
            justify-content: center;

            select {
                min-width: 150px;
                text-align: center;

                option {
                    text-align: center;
                }
            }
        }

    }
</style>